import * as React from "react";
import { IconProps } from "./IconProps";

export const IconArrowDown = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M10.1021 6.39751C10.3216 6.17798 10.3216 5.82204 10.1021 5.60251C9.88255 5.38297 9.52662 5.38297 9.30708 5.60251L6.56208 8.34751V2.0625C6.56208 1.75184 6.31024 1.5 5.99958 1.5C5.68892 1.5 5.43708 1.75184 5.43708 2.0625V8.34751L2.69207 5.60251C2.47254 5.38297 2.11661 5.38297 1.89707 5.60251C1.67754 5.82204 1.67754 6.17797 1.89707 6.39751L5.60183 10.1023C5.8215 10.3219 6.17766 10.3219 6.39733 10.1023L10.1021 6.39751Z"
          fill={color}
        />
      </svg>
    );
  },
);
